import { IUpdateAcoesPreventivasUseCase } from "../../../presentation/useCases/update/updade_acoes_preventivas_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

export class UpdateAcoesPreventivasUseCase implements IUpdateAcoesPreventivasUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateAcoesPreventivas(
    IdAcaoQualidade: number,
    Tipo: number | null,
    AcaoAberta: boolean | null,
    Data: Date | null,
    Numero: number | null,
    DescricaoProblema: string | null,
    AnaliseCausa: string | null,
    Abrangencia: string | null,
    RequisitoNorma: string | null,
    EvidenciaObjetiva: string | null,
    IdCentroCusto: number | null,
    Arquivo1: File | null,
    Arquivo2: File | null,
    Arquivo3: File | null,
    Arquivo4: File | null,
    Arquivo5: File | null,
    RealizarAnalise: boolean | null,
    Justificativa: string | null,
    Evento: string | null,
    Assunto: string | null,
    DescricaoSetor: string | null,
    IdentificadoPor: string | null,
    limparArquivo1: boolean,
    limparArquivo2: boolean,
    limparArquivo3: boolean,
    limparArquivo4: boolean,
    limparArquivo5: boolean,
  ): Promise<void> {
    const arquivoNome1 = Arquivo1 !== null ? Arquivo1.name : null;
    const arquivoNome2 = Arquivo2 !== null ? Arquivo2.name : null;
    const arquivoNome3 = Arquivo3 !== null ? Arquivo3.name : null;
    const arquivoNome4 = Arquivo4 !== null ? Arquivo4.name : null;
    const arquivoNome5 = Arquivo5 !== null ? Arquivo5.name : null;

    await this.repository.updateAcoesPreventivas(
      IdAcaoQualidade,
      Tipo,
      AcaoAberta,
      Data,
      Numero,
      DescricaoProblema,
      AnaliseCausa,
      Abrangencia,
      RequisitoNorma,
      EvidenciaObjetiva,
      IdCentroCusto,
      Arquivo1,
      Arquivo2,
      Arquivo3,
      Arquivo4,
      Arquivo5,
      RealizarAnalise,
      Justificativa,
      Evento,
      Assunto,
      DescricaoSetor,
      IdentificadoPor,
      arquivoNome1,
      arquivoNome2,
      arquivoNome3,
      arquivoNome4,
      arquivoNome5,
      limparArquivo1,
      limparArquivo2,
      limparArquivo3,
      limparArquivo4,
      limparArquivo5,
    );
  }
}
